import { View } from "binder"
import { GenderSelector } from "src/common/reusableComponents/genderSelector/genderSelector";
import { PersonnelEditorViewModel } from "./personnelEditor-viewModel"

export class PersonnelEditorView extends View<PersonnelEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-6FA2BBEA-9F81-45EF-A327-269602FA942D"
    }
    loadHtml(): string {
        let element = require('./personnelEditor.html').default;
        let style = require('./personnelEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v:string) {this._name = v; } public get name(): string {return this._name;} private _name:string;    
    public set lastName(v:string) {this._lastName = v; } public get lastName(): string {return this._lastName;} private _lastName:string;    
    public set nationalCode(v:string) {this._nationalCode = v; } public get nationalCode(): string {return this._nationalCode;} private _nationalCode:string;    
    public set personnelCode(v:string) {this._personnelCode = v; } public get personnelCode(): string {return this._personnelCode;} private _personnelCode:string;    
    public set fatherName(v:string) {this._fatherName = v; } public get fatherName(): string {return this._fatherName;} private _fatherName:string;    
    public set identificationCode(v:string) {this._identificationCode = v; } public get identificationCode(): string {return this._identificationCode;} private _identificationCode:string;
    public set birthDate(v:moment.Moment) {this._birthDate = v; } public get birthDate(): moment.Moment {return this._birthDate;} private _birthDate:moment.Moment;
    public set comment(v:string) {this._comment = v; } public get comment(): string {return this._comment;} private _comment:string;
    public set address(v:string) {this._address = v; } public get address(): string {return this._address;} private _address:string;
    public set cellPhone(v:string) {this._cellPhone = v; } public get cellPhone(): string {return this._cellPhone;} private _cellPhone:string;
    public set isMale(v:boolean) {this._isMale = v; } public get isMale(): boolean {return this._isMale;} private _isMale:boolean;
    public set genderSelector(v: GenderSelector) { this._genderSelector = v; } public get genderSelector(): GenderSelector { return this._genderSelector;} private _genderSelector: GenderSelector;
    public set paymentInfo(v: string) { this._paymentInfo = v; } public get paymentInfo(): string { return this._paymentInfo;} private _paymentInfo: string;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit;} private _canEdit: boolean;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable;} private _isDisable: boolean;
    
    
    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
